<template>
    <form-row title="Scheduled Closing Date" label_class="pb-12">
        <div class="flex flex-col sm:flex-row items-start">
            <div class="-mt-4">
                <input-date
                    label="Date"
                    name="scheduled_closing_date"
                    v-model="scheduled_closing_date"
                    :read_only="read_only"
                    @entered="dateEntered"
                />
            </div>

            <div class="flex-col">
                <div class="pt-3 mt-4 sm:mt-0 flex items-center">
                    <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="scheduled_closing_period_feasibility"
                            v-model="scheduled_closing_period_feasibility"
                            placeholder="Days"
                            :read_only="read_only"
                            @input="feasibilityPeriodEntered"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                        {{ $t('days after Feasibility') }}
                    </span>
                </div>

                <div class="pt-3 mt-4 sm:mt-0 flex items-center">
                    <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="scheduled_closing_period_entitlement"
                            v-model="scheduled_closing_period_entitlement"
                            placeholder="Days"
                            :read_only="read_only"
                            @input="entitlementPeriodEntered"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                        {{ $t('days after Entitlement') }}
                    </span>
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            scheduled_closing_period_feasibility: this.commercial.scheduled_closing_period_feasibility,
            scheduled_closing_period_entitlement: this.commercial.scheduled_closing_period_entitlement,
        }
    },

    computed: {
        scheduled_closing_date_from_period() {
            if (! store.state.feasibility_date && ! store.state.entitlement_date) {
                return;
            }

            if (this.scheduled_closing_period_feasibility) {
                if (this.isValidDate(store.state.feasibility_date)) {
                    return dayjs(store.state.feasibility_date.slice(0, 10))
                        .add({ day: this.scheduled_closing_period_feasibility })
                        .format('YYYY-MM-DD')
                } else {
                    return null;
                }
            }

            if (this.isValidDate(store.state.entitlement_date)
                && this.scheduled_closing_period_entitlement
            ) {
                return dayjs(store.state.entitlement_date.slice(0, 10))
                    .add({ day: this.scheduled_closing_period_entitlement })
                    .format('YYYY-MM-DD')
            }
        },
        scheduled_closing_date: {
            get() {
                return store.state.scheduled_closing_date;
            },
            set(val) {
                store.state.scheduled_closing_date = val;
            },
        },
    },

    methods: {
        dateEntered() {
            this.scheduled_closing_period_feasibility = null;
            this.scheduled_closing_period_entitlement = null;
        },
        feasibilityPeriodEntered(value) {
            if (! value || ! store.state.feasibility_date) {
                this.scheduled_closing_date = null;
            }

            this.scheduled_closing_period_entitlement = null;
        },
        entitlementPeriodEntered(value) {
            if (! value || ! store.state.entitlement_date) {
                this.scheduled_closing_date = null;
            }

            this.scheduled_closing_period_feasibility = null;
        },
    },

    watch: {
        scheduled_closing_date_from_period(val) {
            if (val) {
                this.scheduled_closing_date = val;
            }
        },
    },
}
</script>
